(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/game-analyzes/build-race-bet.js') >= 0) return;  svs.modules.push('/components/sport/game-analyzes/build-race-bet.js'); "use strict";



const buildUniqueRankRows = svs.racing.build_unique_rank_row.buildUniqueRankRows;
const buildRaceBet = (gameAnalyzes, system) => {
  const predictionsInCurrentSystem = [];
  const horses = {};
  gameAnalyzes.forEach(gameAnalyze => {
    if (gameAnalyze.parsedPrediction && gameAnalyze.parsedPrediction.prediction && Array.isArray(gameAnalyze.parsedPrediction.prediction)) {
      horses[gameAnalyze.parsedPrediction.prediction[0].participantId] = {
        horseName: gameAnalyze.title.split('-')[0].trim(),
        driverName: gameAnalyze.title.split('-')[1].trim(),
        startNumber: gameAnalyze.properties.cnt_eventNumber
      };
      gameAnalyze.parsedPrediction.prediction.forEach(item => {
        if (item.system === system) {
          predictionsInCurrentSystem.push(item);
        }
      });
    }
  });
  const picks = {
    rows: [{
      position: '1',
      horses: [],
      dataRow: []
    }, {
      position: '2',
      horses: [],
      dataRow: []
    }, {
      position: '3',
      horses: [],
      dataRow: []
    }, {
      position: '4',
      horses: [],
      dataRow: []
    }, {
      position: '5',
      horses: [],
      dataRow: []
    }],
    isValidSystem: false,
    description: ''
  };
  const picksDataRows = [];
  picks.rows.forEach(pick => {
    predictionsInCurrentSystem.forEach(prediction => {
      prediction.outcomes.forEach(outcome => {
        if (outcome.outcomeNumber === pick.position) {
          prediction.horseInfo = horses[prediction.participantId];
          pick.horses.push(prediction);
          if (prediction.horseInfo && prediction.horseInfo.startNumber) {
            pick.dataRow.push(prediction.horseInfo.startNumber);
          }
        }
      });
      pick.showHorseInfo = pick.horses.length === 1;
    });
    picksDataRows.push(pick.dataRow);
  });
  if (predictionsInCurrentSystem && predictionsInCurrentSystem[0] && predictionsInCurrentSystem[0].system) {
    const currentSystemSize = parseInt(predictionsInCurrentSystem[0].system, 10);
    picks.isValidSystem = buildUniqueRankRows(picksDataRows, 5).length === currentSystemSize;
    picks.description = "".concat(currentSystemSize, " ").concat(currentSystemSize > 1 ? 'rader' : 'rad', " \xE1 20 kr = ").concat(currentSystemSize * 20, " kr");
  }
  return picks;
};
if (svs.isServer) {
  module.exports = buildRaceBet;
} else {
  setGlobal('svs.sport.gameAnalyzes.buildRaceBet', buildRaceBet);
}
 })(window);